





















import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    subtitle: 'Notifications',
    selectedItem: 0,
  }),
  props: ['messages', 'width', 'height', 'listHeight'],
  methods: {
    getIcon(type: string) {
      switch (type) {
        case 'success':
          return 'mdi-comment-check-outline'
        case 'error':
          return 'mdi-comment-alert-outline'
        default:
          return 'mdi-comment-outline'
      }
    },
  },
})
